import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  input,
} from '@angular/core';
import { HeaderService } from './data-access/header.service';
import { MatDrawer, MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RoutesExtended } from '../../sidebar-types';
import { TooltipDirective } from '../../../../../../shared/directives/tooltip/tooltip.directive';

@Component({
  selector: 'side-bar-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  imports: [CommonModule, TooltipDirective, RouterModule],
})
export class HeaderComponent implements OnInit {
  @Input('sideNav') drawer: MatDrawer;
  routeConfig = input.required<RoutesExtended>();
  routePrefix = input.required<string>();

  @Input('pages') pages;

  @Output('openPage') _openPage = new EventEmitter<any>();

  constructor(
    public headerService: HeaderService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.headerService.setRouteConfig(this.routeConfig());
    this.headerService.setRoutePrefix(this.routePrefix());
  }

  goBack(route: string | Array<string>): void {
    this.headerService.navigateToParent(route);
  }

  test() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  close() {
    this.drawer.close();
  }
}
